




























































































import {Vue, Component, Ref, Prop} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import {
  Collapse,
  PriceWings,
  SelectWings,
  SpoilerWings,
  ToggleWings
} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyError} from "@/utils/notify-helper";
import { TariffZoneGroupItem, TarificationTransports, TarificationTypes } from "@/store/tarification/types";
import { extend } from 'vee-validate';
import { ServiceProviderItem } from '@/store/settings/service_providers/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {MsgTransports} from "@/store/types";

@Component({
  components: {SelectWings, PriceWings, ToggleWings, Collapse, SpoilerWings, CollapseTransition}
})
export default class TariffZoneGroup extends Vue {

  @Ref('validator') validator: any;

  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;

  @Action("getTariffZoneGroupItem") actionGetItem: any;
  @Action("saveTariffZoneGroupItem") actionSave: any;
  @Action("deleteTariffZoneItem") actionDelete: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("actionLog") actionLog: any;

  @Getter("serviceProviders") serviceProvidersList!: ServiceProviderItem[];
  @Getter("tariffZones") tariffZonesResponse: any;

  chargingList:string[] = ["SENDING","DELIVERY"];
  chargingCallList:string[] = ["SEC","MIN"];
  routingList:string[] = ["MSISDN","MCC/MNC"];

  private partnerType: TarificationTypes = TarificationTypes.PARTNER
  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};
  private CallTransport: MsgTransports = MsgTransports.CALL;

  defaultItem(): any {
    return {
      routing: "",
      charging: "",
      is_all_operators_allowed: true,
      operators: [],
    };
  }

  created() {
    switch (this.type) {
      case TarificationTypes.PARTNER:
        this.actionGetServiceProviders({transport: [this.transport]}).then(() => {
          if (this.item.is_all_operators_allowed) {
            this.item.operators = this.serviceProvidersList.map((provider: ServiceProviderItem) => {
              return {
                id: provider.id,
                name: provider.name,
                is_allowed: false,
              };
            });
          }
        });
        break;
    }
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Viewing",
      action_status: "success",
      object_type: "Tariff zones' group",
      addititional_info: getTranslatedParams(
          { partner: this.$route.params.partner_id, service_provider: this.$route.params.operator_id }
      )
    }
    let object = {
      partner_id: this.$route.params.partner_id,
      operator_id: this.$route.params.operator_id,
      id: this.$route.params.id,
      transport: this.transport.toLowerCase()
    };
    this.actionGetItem(object).then((data: TariffZoneGroupItem) => {
      this.item = Object.assign({}, this.item, data);
      this.itemSaved = cloneDeep(this.item);
      this.actionLog(this.logObject);
    }).catch(()=> this.actionLog({...this.logObject, action_status: "failed"}));
    this.validationSetup();
  }

  validationSetup() {
    extend('allowed_operators_required', {
      validate: () => {
        let result = Boolean(this.item.operators
            ?.find((operator: any) => operator.is_allowed));
        return result;
      },
      message: 'Не выбран ни один Поставщик услуг',
    });
  }

  back(): void {
    this.$router.push(`/${this.transport}/tarification/${this.type}/`);
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        let object = {
          partner_id: this.$route.params.partner_id,
          operator_id: this.$route.params.operator_id,
          item: this.item,
          transport: this.transport.toLowerCase()
        };
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Tariff zones' group",
          addititional_info: getTranslatedParams({partner: this.$route.params.partner_id, service_provider: this.$route.params.operator_id })
        }
        try {
          await this.actionSave(object);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          reject();
          notifyError(error);
          this.actionLog({...this.logObject, action_status: "failed"});
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  beforeLeave(to: any, from: any, next: any): void {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
